import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const BlogGestion = () => {
  // Estado para gestionar las entradas del blog
  const [entradas, setEntradas] = useState([]);
  const [titulo, setTitulo] = useState('');
  const [contenido, setContenido] = useState('');
  const [imagen, setImagen] = useState(null);

  // Manejo de cambio en el editor de texto
  const handleEditorChange = (value) => {
    setContenido(value);
  };

  // Manejo de carga de imagen
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImagen(URL.createObjectURL(file)); // Previsualización de la imagen
    }
  };

  // Manejo de publicación de la entrada
  const handlePublicar = () => {
    if (!titulo || !contenido) {
      alert("El título y el contenido son obligatorios");
      return;
    }

    // Crear una nueva entrada
    const nuevaEntrada = {
      id: entradas.length + 1,
      titulo,
      contenido,
      imagen,
    };

    // Agregar la entrada a la lista
    setEntradas([nuevaEntrada, ...entradas]);
    
    // Limpiar los campos
    setTitulo('');
    setContenido('');
    setImagen(null);
  };

  return (
    <div className="container-fluid p-0">
      <h1 className="h3 mb-3">Gestión de Blog</h1>

      <div className="row">
        {/* Formulario para crear una nueva entrada */}
        <div className="col-12 col-lg-8 col-xxl-8">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Nueva Entrada</h5>
              
              <div className="mb-3">
                <label htmlFor="title" className="form-label">Título</label>
                <input 
                  type="text" 
                  className="form-control" 
                  id="title" 
                  value={titulo}
                  onChange={(e) => setTitulo(e.target.value)}
                  placeholder="Escribe el título de la entrada" 
                />
              </div>

              <div className="mb-3">
                <label htmlFor="image" className="form-label">Subir Imagen</label>
                <input 
                  type="file" 
                  className="form-control" 
                  id="image"
                  accept="image/*"
                  onChange={handleImageUpload}
                />
                {imagen && (
                  <div className="mt-3">
                    <img src={imagen} alt="Previsualización" width="100%" className="img-fluid" />
                  </div>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label">Contenido</label>
                <ReactQuill 
                  value={contenido}
                  onChange={handleEditorChange}
                  placeholder="Escribe el contenido del blog..."
                />
              </div>

              <button className="btn btn-primary" onClick={handlePublicar}>
                Publicar Entrada
              </button>
            </div>
          </div>
        </div>

        {/* Lista de entradas publicadas */}
        <div className="col-12 col-lg-4 col-xxl-4">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Mis Entradas</h5>
              <ul className="list-group">
                {entradas.length > 0 ? (
                  entradas.map((entrada) => (
                    <li key={entrada.id} className="list-group-item">
                      <h6>{entrada.titulo}</h6>
                      {entrada.imagen && (
                        <img src={entrada.imagen} alt={entrada.titulo} className="img-fluid mb-2" />
                      )}
                      <div dangerouslySetInnerHTML={{ __html: entrada.contenido }} />
                    </li>
                  ))
                ) : (
                  <li className="list-group-item">No hay entradas publicadas.</li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogGestion;
